// @flow

import React from "react";
import { type GraphQLSchema, type GraphQLField, type GraphQLArgument, GraphQLNonNull, GraphQLList } from 'graphql';

import RootField from "./GraphQLExplorerDocumentation/RootField";
import Scalar from "./GraphQLExplorerDocumentation/Scalar";
import { getGraphQLSchema } from "./schema";

type Props = {
  params: {
    field: string
  }
};

export default class GraphQLExplorerDocumentationField extends React.PureComponent<Props> {
  render() {
    const fieldname = this.props.params.field;
    const schema: GraphQLSchema = getGraphQLSchema();

    let fieldType = 'query';
    const queryType = schema.getQueryType();
    let field = queryType && queryType.getFields()[fieldname];

    if (!field) {
      fieldType = 'mutation';
      const mutationType = schema.getMutationType();
      field = mutationType && mutationType.getFields()[fieldname];
    }

    if (!field) {
      return (
        <div>
          <h2>Not Found</h2>
          <p>No field with that name could be found.</p>
        </div>
      );
    }

    let nonNull = false;
    let array = false;
    let nonNullItems = false;
    let returnType = field.type;

    if (returnType instanceof GraphQLNonNull) {
      nonNull = true;
      returnType = returnType.ofType;
    }

    if (returnType instanceof GraphQLList) {
      array = true;
      returnType = returnType.ofType;
    }

    if (returnType instanceof GraphQLNonNull) {
      nonNullItems = true;
      returnType = returnType.ofType;
    }

    if (returnType instanceof GraphQLList) {
      throw new TypeError("Return type was still a List after processing. This shouldn't be possible.");
    }

    // TODO: cm-s-graphql is a hack; make it suck less
    return (
      <div className="cm-s-graphql">
        <h2>{fieldType[0].toUpperCase() + fieldType.slice(1)}: <RootField name={`${fieldType}.${fieldname}`} className="monospace" /></h2>
        {field.isDeprecated && <p>This query is deprecated. {field.deprecationReason}</p>}
        <p>{field.description || 'No description available.'}</p>
        {this.renderArguments(field)}
        <h3>Returns</h3>
        <span className="monospace">
          <span className="cm-punctuation">{array && '['}</span>
          <Scalar name={returnType.name} />
          <span className="cm-punctuation">
            {nonNullItems && '!'}
            {array && ']'}
            {nonNull && '!'}
          </span>
        </span>
        <p>{returnType.description || 'No description available.'}</p>
      </div>
    );
  }

  renderArguments(field: GraphQLField<any, any>) {
    return (
      <React.Fragment>
        <h3 id="arguments">Arguments</h3>
        {(
          field.args && field.args.length > 0
            ? field.args.map(this.renderArgument)
            : <p>No arguments accepted.</p>
        )}
      </React.Fragment>
    );
  }

  renderArgument(argument: GraphQLArgument) {
    let nonNull = false;
    let array = false;
    let nonNullItems = false;
    let type = argument.type;

    if (type instanceof GraphQLNonNull) {
      nonNull = true;
      type = type.ofType;
    }

    if (type instanceof GraphQLList) {
      array = true;
      type = type.ofType;
    }

    if (type instanceof GraphQLNonNull) {
      nonNullItems = true;
      type = type.ofType;
    }

    if (type instanceof GraphQLList) {
      throw new TypeError("Type was still a List after processing. This shouldn't be possible.");
    }

    return (
      <React.Fragment key={argument.name}>
        <h4 id={argument.name} className="monospace">
          <span className="cm-attribute">{argument.name}</span>
          <span className="cm-punctuation">: {array && '['}</span>
          <Scalar name={type.name} />
          <span className="cm-punctuation">
            {nonNullItems && '!'}
            {array && ']'}
            {nonNull && '!'}
          </span>
        </h4>
        <p>{argument.description || 'No description available.'}</p>
      </React.Fragment>
    );
  }
}
